import type { RiskRecognitionHighlight } from '@cobliteam/api-lib/src/dashboard/riskRecognitions/Types';

// Param de deep link do drawer de risco (`?risk-recognition-drawer=<bucket>`). Card/toast/sino setam, o drawer resolve.
export const RISK_DRAWER_PARAM = 'risk-recognition-drawer';

// Regras de risco conhecidas (gate de render). O backend pode mandar regras novas antes do front saber
// renderá-las — só mostramos as mapeadas.
export const RISK_RECOGNITION_RULE_NAMES = ['long_journey', 'severe_speed', 'fatigue'] as const;
export type RiskRecognitionRuleName = (typeof RISK_RECOGNITION_RULE_NAMES)[number];

export const isKnownRiskRule = (ruleName: string | undefined): ruleName is RiskRecognitionRuleName =>
  !!ruleName && (RISK_RECOGNITION_RULE_NAMES as readonly string[]).includes(ruleName);

// Aceita `undefined` (o highlight vem do cache da query, `T | undefined`). Gate de render do card/toast/sino:
// tem highlight, tem detecção, é regra conhecida, e não foi dispensado nesta sessão (bucket dispensado).
export const isHighlightRenderable = (highlight: RiskRecognitionHighlight | null | undefined, dismissedBucketEnd: string | null): boolean =>
  !!highlight && highlight.detection_count > 0 && isKnownRiskRule(highlight.metadata?.rule_name) && highlight.time_bucket_end !== dismissedBucketEnd;
